import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=f38b2948&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=f38b2948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38b2948",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f38b2948')) {
      api.createRecord('f38b2948', component.options)
    } else {
      api.reload('f38b2948', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=f38b2948&scoped=true&", function () {
      api.rerender('f38b2948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8nsx3mkVPnagG/JS/comp/SearchFilterTokens.vue"
export default component.exports